module.exports = __webpack_public_path__ + "assets/font/Tomorrow-Thin-73be8dcd.ttf";